import NewYearGachaGift, { NewYearGachaGiftRarity } from "../model/NewYearGachaGift";
import NewYearGachaProgress from "../model/NewYearGachaProgress";

export const MAX_PULLS_PER_DAY = 3;

export const COMMON_GIFTS = [
    NewYearGachaGift.AutoLayoutGingerbreadMan,
    NewYearGachaGift.PixelPerfectCandyCane,
    NewYearGachaGift.HolidayEmergencyKit,
    NewYearGachaGift.ZoClaus,
    NewYearGachaGift.BranOrnamentEngineer,
    NewYearGachaGift.TipsyTreeJan,
    NewYearGachaGift.AttemptedTreeTopper,
    NewYearGachaGift.StudioApartmentInNorthPole,
    NewYearGachaGift.VisitorFromPier39,
    NewYearGachaGift.NorthPolesNewDesignLead,
    NewYearGachaGift.TipsyOrnaments
];

export const RARE_GIFTS = [
    NewYearGachaGift.WallpaperForest,
    NewYearGachaGift.WallpaperTipsyTrio,
    NewYearGachaGift.WallpaperBeanie,
    NewYearGachaGift.WallpaperGlobe,
    NewYearGachaGift.WallpaperAngel,
    NewYearGachaGift.WallpaperUglySweater,
    NewYearGachaGift.WallpaperWatercolor,
    NewYearGachaGift.SnowButton
];

export const GIFT_NAMES: Record<NewYearGachaGift, string> = {
    [NewYearGachaGift.AutoLayoutGingerbreadMan]: "Auto Layout Gingerbread Man",
    [NewYearGachaGift.PixelPerfectCandyCane]: "Pixel Perfect Candy Cane",
    [NewYearGachaGift.HolidayEmergencyKit]: "Holiday Emergency Kit",
    [NewYearGachaGift.ZoClaus]: "Zo Claus",
    [NewYearGachaGift.BranOrnamentEngineer]: "Bran, Ornament Engineer",
    [NewYearGachaGift.TipsyTreeJan]: "Tipsy Tree Jan",
    [NewYearGachaGift.AttemptedTreeTopper]: "Attempted Tree Topper",
    [NewYearGachaGift.StudioApartmentInNorthPole]: "Studio Apartment in North Pole",
    [NewYearGachaGift.VisitorFromPier39]: "Visitor from Pier 39",
    [NewYearGachaGift.NorthPolesNewDesignLead]: "North Pole's New Design Lead",
    [NewYearGachaGift.TipsyOrnaments]: "Tipsy Ornaments",
    [NewYearGachaGift.WallpaperForest]: "Wallpaper #1 — Forest",
    [NewYearGachaGift.WallpaperTipsyTrio]: "Wallpaper #2 — Tipsy Trio",
    [NewYearGachaGift.WallpaperBeanie]: "Wallpaper #3 — Beanie",
    [NewYearGachaGift.WallpaperGlobe]: "Wallpaper #4 — Globe",
    [NewYearGachaGift.WallpaperAngel]: "Wallpaper #5 — Angel",
    [NewYearGachaGift.WallpaperUglySweater]: "Wallpaper #6 — Ugly Sweater",
    [NewYearGachaGift.WallpaperWatercolor]: "Wallpaper #7 — Watercolor",
    [NewYearGachaGift.SnowButton]: "“Let It Snow” Button"
};

export const GIFT_IMAGE_PATHS: Record<NewYearGachaGift, string> = {
    [NewYearGachaGift.AutoLayoutGingerbreadMan]: "img/newYearGacha/gift/autoLayoutGingerbreadMan.png",
    [NewYearGachaGift.PixelPerfectCandyCane]: "img/newYearGacha/gift/pixelPerfectCandyCane.png",
    [NewYearGachaGift.HolidayEmergencyKit]: "img/newYearGacha/gift/holidayEmergencyKit.png",
    [NewYearGachaGift.ZoClaus]: "img/newYearGacha/gift/santaZo.png",
    [NewYearGachaGift.BranOrnamentEngineer]: "img/newYearGacha/gift/elfBran.png",
    [NewYearGachaGift.TipsyTreeJan]: "img/newYearGacha/gift/treeJen.png",
    [NewYearGachaGift.AttemptedTreeTopper]: "img/newYearGacha/gift/attemptedTreeTopper.png",
    [NewYearGachaGift.StudioApartmentInNorthPole]: "img/newYearGacha/gift/studioApartmentInNorthPole.png",
    [NewYearGachaGift.VisitorFromPier39]: "img/newYearGacha/gift/visitorFromPier39.png",
    [NewYearGachaGift.NorthPolesNewDesignLead]: "img/newYearGacha/gift/northPolesNewDesignLead.png",
    [NewYearGachaGift.TipsyOrnaments]: "img/newYearGacha/gift/tipsyOrnaments.png",
    [NewYearGachaGift.WallpaperForest]: "img/newYearGacha/gift/wallpaperForest.png",
    [NewYearGachaGift.WallpaperTipsyTrio]: "img/newYearGacha/gift/wallpaperTipsyTrio.png",
    [NewYearGachaGift.WallpaperBeanie]: "img/newYearGacha/gift/wallpaperBeanie.png",
    [NewYearGachaGift.WallpaperGlobe]: "img/newYearGacha/gift/wallpaperGlobe.png",
    [NewYearGachaGift.WallpaperAngel]: "img/newYearGacha/gift/wallpaperAngel.png",
    [NewYearGachaGift.WallpaperUglySweater]: "img/newYearGacha/gift/wallpaperUgly.png",
    [NewYearGachaGift.WallpaperWatercolor]: "img/newYearGacha/gift/wallpaperWatercolor.png",
    [NewYearGachaGift.SnowButton]: "img/newYearGacha/gift/snowButton.png"
};

export const GIFT_THUMBNAIL_IMAGE_PATHS: Record<NewYearGachaGift, string> = {
    [NewYearGachaGift.AutoLayoutGingerbreadMan]: "img/newYearGacha/gift/thumbnail/autoLayoutGingerbreadMan.png",
    [NewYearGachaGift.PixelPerfectCandyCane]: "img/newYearGacha/gift/thumbnail/pixelPerfectCandyCane.png",
    [NewYearGachaGift.HolidayEmergencyKit]: "img/newYearGacha/gift/thumbnail/holidayEmergencyKit.png",
    [NewYearGachaGift.ZoClaus]: "img/newYearGacha/gift/thumbnail/santaZo.png",
    [NewYearGachaGift.BranOrnamentEngineer]: "img/newYearGacha/gift/thumbnail/elfBran.png",
    [NewYearGachaGift.TipsyTreeJan]: "img/newYearGacha/gift/thumbnail/treeJen.png",
    [NewYearGachaGift.AttemptedTreeTopper]: "img/newYearGacha/gift/thumbnail/attemptedTreeTopper.png",
    [NewYearGachaGift.StudioApartmentInNorthPole]: "img/newYearGacha/gift/thumbnail/studioApartmentInNorthPole.png",
    [NewYearGachaGift.VisitorFromPier39]: "img/newYearGacha/gift/thumbnail/visitorFromPier39.png",
    [NewYearGachaGift.NorthPolesNewDesignLead]: "img/newYearGacha/gift/thumbnail/northPolesNewDesignLead.png",
    [NewYearGachaGift.TipsyOrnaments]: "img/newYearGacha/gift/thumbnail/tipsyOrnaments.png",
    [NewYearGachaGift.WallpaperForest]: "img/newYearGacha/gift/thumbnail/wallpaperForest.png",
    [NewYearGachaGift.WallpaperTipsyTrio]: "img/newYearGacha/gift/thumbnail/wallpaperTipsyTrio.png",
    [NewYearGachaGift.WallpaperBeanie]: "img/newYearGacha/gift/thumbnail/wallpaperBeanie.png",
    [NewYearGachaGift.WallpaperGlobe]: "img/newYearGacha/gift/thumbnail/wallpaperGlobe.png",
    [NewYearGachaGift.WallpaperAngel]: "img/newYearGacha/gift/thumbnail/wallpaperAngel.png",
    [NewYearGachaGift.WallpaperUglySweater]: "img/newYearGacha/gift/thumbnail/wallpaperUgly.png",
    [NewYearGachaGift.WallpaperWatercolor]: "img/newYearGacha/gift/thumbnail/wallpaperWatercolor.png",
    [NewYearGachaGift.SnowButton]: "img/newYearGacha/gift/thumbnail/snowButton.png"
};

export function getYear(): number {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // Use current year in January, otherwise use next year.
    return currentMonth === 0 ? currentYear : currentYear + 1;
}

export function hasProgress(
    progressByYear: Record<number, NewYearGachaProgress | undefined>
): boolean {
    const progress = progressByYear[getYear()];

    return progress !== undefined;
}

export function getRemainingPulls(
    progressByYear: Record<number, NewYearGachaProgress | undefined>
): number {
    const progress = progressByYear[getYear()];
    if (!progress) {
        return MAX_PULLS_PER_DAY;
    }

    const date = new Date().toDateString();
    if (progress.lastPullDate !== date) {
        return MAX_PULLS_PER_DAY;
    }

    return Math.max(0, MAX_PULLS_PER_DAY - progress.numberOfPulls);
}

export function getCollectedGifts(
    progressByYear: Record<number, NewYearGachaProgress | undefined>
): NewYearGachaGift[] {
    const progress = progressByYear[getYear()];

    return progress?.collectedGifts || [];
}

export function getGiftRarityColor(rarity: NewYearGachaGiftRarity) {
    switch (rarity) {
        case NewYearGachaGiftRarity.Common:
            return { normal: "var(--marker-jade)", light: "var(--marker-jade-15pc)" };
        case NewYearGachaGiftRarity.Rare:
            return { normal: "var(--marker-deep-purple)", light: "var(--marker-deep-purple-15pc)" };
        default:
            throw new Error(`Unknown rarity: ${rarity}`);
    }
}

export function getWallpaperKey(gift: NewYearGachaGift): string | null {
    switch (gift) {
        case NewYearGachaGift.WallpaperForest:
            return "06c34fd4";
        case NewYearGachaGift.WallpaperTipsyTrio:
            return "8a7f7a25";
        case NewYearGachaGift.WallpaperBeanie:
            return "b2392a96";
        case NewYearGachaGift.WallpaperGlobe:
            return "71679bcb";
        case NewYearGachaGift.WallpaperAngel:
            return "2a13ed77";
        case NewYearGachaGift.WallpaperUglySweater:
            return "765db462";
        case NewYearGachaGift.WallpaperWatercolor:
            return "17fde59f";
        default:
            return null;
    }
}
